import React from "react"
import { Link } from "gatsby"

const NavbarLink = ({ url, title }) => (
  <>
    <Link className="nav-link" activeClassName="active" to={url}>
      <span>{title}</span>
    </Link>
  </>
)

export default NavbarLink
